<template>
  <div>
    <div class="search" v-if="tableData.form && tableData.showForm==false?false:true">
      <!-- table查询表单 -->
      <formCondition :conditionForm="tableData.form" :conditionTab="tableData.tab" :conditionCol="tableData.column"
                     :searchBtn="tableData.searchBtn" @searchClick="searchClick"></formCondition>
    </div>
    <div class="table_title" v-if="tableData.title">
      <div class="table_title_icon"></div>
      {{ tableData.title }}
    </div>
    <el-table ref="tableRef" :border="true" :data="tableData.data" :cell-style="{ padding:'0px'}"
              :row-style="{ height: '41px'}"
              style="margin-top: -5px" :style="{'width':isForm?'99%':'100%'}"
              :stripe="isStripe" :height="tableData.height?tableData.height:null"
              :show-summary="tableData.summary==true?true:false" :summary-method="getSummaries"
              @row-click="(row, column, event)=>{if(tableData.rowClick)tableData.rowClick(row)}"
              @selection-change="handleSelectionChange"
              @sort-change="(row)=>{if(tableData.sortClick)tableData.sortClick(row)}"
              :span-method="(e)=>{if(tableData.spanMethod)return tableData.spanMethod(e.row,e.column,e.rowIndex,e.columnIndex)}">
      <!-- 循环自定义列 -->
      <template v-for="(item, index) in tableData.column" :key="index">
        <!-- 选择列 -->
        <el-table-column type="selection" width="50" align="center" v-if="item.type == 'selection'"></el-table-column>
        <!-- 序号列 -->
        <el-table-column type="index" label="序号" width="55" align="center" label-class-name="table_column"
                         v-else-if="item.type == 'index'"></el-table-column>
        <!-- 自定义列 -->
        <el-table-column :prop="item.prop" label-class-name="table_column" align="center"
                         :min-width="item.width?item.width:item.type=='time'?155:item.type=='tag'?80:item.type=='textLong'?200:
                                 item.type=='image'?100:120"
                         :sortable="item.sort?item.sort:false" :show-overflow-tooltip="item.type=='textLong'"
                         v-else-if="item.visible===false?false:item.show===false?false:true"
                         :fixed="item.type=='button'&&(item.fixed==false?false:true)?'right':false">
          <template #header>
            <div v-if="item.type == 'button'">
              {{ item.label ? item.label : '操作' }}
            </div>
            <div v-else>
              {{ item.label }}
              <el-popover v-if="item.popover" :placement="item.popover&&item.popover.placement"
                          :width="item.popover&&item.popover.width?item.popover.width:200" trigger="hover">
                <template #reference>
                  <svg-icon style="position: relative;top: 2px;" icon-class="wenhao"></svg-icon>
                </template>
                <template #default>
                  <div v-html="item.popover&&item.popover.content?item.popover.content:''"></div>
                </template>
              </el-popover>
            </div>
          </template>
          <template #default="scope">
            <!-- index序号带删除 -->
            <div v-if="item.type == 'indexDel'" :style="item.style&&scope.row['textStyle']?scope.row['textStyle']:''">
              <div>{{ scope.$index + 1 }}</div>
              <el-button class="item_card_btn" type="danger" circle
                         v-if="scope.row[item.prop + 'Btn']==false?false:true"
                         @click="(e)=>{if((item.click)&&item.disabled==true?false:true)item.click(e, scope.row, scope.$index)}">
                <el-icon class="item_card_btn_icon" size="14" color="#ffffff">
                  <Close/>
                </el-icon>
              </el-button>
            </div>
            <!-- text -->
            <div v-if="item.type == 'text'" @click="(e)=>{if(item.click)item.click(scope.row,scope.$index,index)}"
                 :style="item.style&&scope.row['textStyle']?scope.row['textStyle']:''">
              {{ scope.row[item.prop] }}
            </div>
            <!-- textBr,带换行和placeholder提示文本 -->
            <div style="cursor: pointer" v-if="item.type == 'textBr'"
                 @click="(e)=>{if(item.click)item.click(scope.row,scope.$index,index)}">
              <pre v-if="scope.row[item.prop]" style="white-space: pre-wrap;">{{ scope.row[item.prop] }}</pre>
              <div v-else style="color: #afafaf;">{{ item.placeholder }}</div>
            </div>
            <!-- textLong 长文本,多出部分隐藏,用组件提示-->
            <div v-if="item.type == 'textLong'" class="table_textLong">{{ scope.row[item.prop] }}</div>
            <!-- html 自定义的html文本-->
            <div v-if="item.type == 'html'" >
              <el-popover v-if="item.columnPopover&&scope.row['columnPopover']" :placement="item.columnPopover&&item.columnPopover.placement"
                          :width="item.columnPopover&&item.columnPopover.width?item.columnPopover.width:200" trigger="hover">
                <template #reference>
                  <div v-html="scope.row[item.prop]"></div>
                </template>
                <template #default>
                  <div v-html="item.columnPopover&&scope.row['columnPopover']"></div>
                </template>
              </el-popover>
              <div v-else v-html="scope.row[item.prop]"
                   @click="(e)=>{if(item.click)item.click(scope.row,scope.$index,index)}"></div>


            </div>
            <!-- time -->
            <div v-if="item.type == 'time'">
              {{
                item.format && scope.row[item.prop] ? dayJs(scope.row[item.prop]).format(item.format) : scope.row[item.prop]
              }}
            </div>
            <!-- switch -->
            <el-switch v-if="item.type == 'switch'" :model-value="scope.row[item.prop]"
                       :loading="item.loading" active-value="1" inactive-value="0"
                       @change="(e)=>{if(item.change)item.change(e, scope.row, scope.$index)}"
            ></el-switch>
            <!-- image -->
            <div v-if="item.type == 'image'&&scope.row[item.prop]">
              <el-image class="table_img" :hide-on-click-modal="true" :preview-teleported="true"
                        :preview-src-list="[scope.row[item.prop]]"
                        :src="scope.row[item.prop]" :lazy="true"></el-image>
            </div>
            <!-- images-多张图片 -->
            <div v-if="item.type == 'images'&&scope.row[item.prop]">
              <el-image v-for="temp in scope.row[item.prop]" class="table_img" :hide-on-click-modal="true"
                        :preview-teleported="true"
                        :preview-src-list="scope.row[item.prop]"
                        :src="temp" :lazy="true"></el-image>
            </div>
            <!-- qrcode -->
            <div v-if="item.type == 'qrcode'&&scope.row[item.prop]">
              <el-image class="table_img" @click="(e)=>{if(item.click)item.click(e, scope.row ,scope.$index)}"
                        :src="scope.row[item.prop]" :lazy="true"></el-image>
            </div>
            <!-- tag 显示类型(tagsType/tag.type):'默认空'/success/info/warning/danger -->
            <div v-if="item.type == 'tag'">
              <!-- 有tags集合时,根据集合关系显示数据 -->
              <template v-if="item.tags &&  scope.row[item.prop] !== null && scope.row[item.prop] !== undefined">
                <template v-for="tag in item.tags" :key="tag.value">
                  <el-tag v-if="tag.value == scope.row[item.prop]" :text-color="tag.textColor?tag.textColor:''" :color="tag.color?tag.color:''" :type="tag.type?tag.type:'primary'">{{ tag.text }}
                  </el-tag>
                </template>
              </template>
              <!-- 无tags集合时,直接显示数据, tagsType同上面的tag.type -->
              <template v-else-if="scope.row[item.prop]">
                <el-tag :type="item.tagsType?item.tagsType:'primary'">{{ scope.row[item.prop] }}</el-tag>
              </template>
              <template v-else>
                <div style="color: #afafaf;">{{ item.placeholder }}</div>
              </template>
            </div>
            <!-- input -->
            <template v-if="item.type == 'input'">
              <el-input v-model.trim="scope.row[item.prop]" :disabled="scope.row[item.prop+'disabled']?true:false"
                        @input="handleInput(item, scope.$index)" @blur="handleBlur(item, scope.$index)"
                        :maxlength="item.max?item.max:'200'"
                        :placeholder="item.placeholder?item.placeholder:'请输入' + item.label">
                <template #append v-if="scope.row[item.prop + '_unit']">{{ scope.row[item.prop + '_unit'] }}</template>
              </el-input>
            </template>
            <!-- input带删除 -->
            <template v-if="item.type == 'inputDel'">
              <el-input v-model.trim="scope.row[item.prop]" :disabled="scope.row[item.prop+'disabled']?true:false"
                        style="margin-left: 10px;width:calc(100% - 10px);"
                        @input="handleInput(item, scope.$index)" @blur="handleBlur(item, scope.$index)"
                        :maxlength="item.max?item.max:'200'"
                        :placeholder="item.placeholder?item.placeholder:'请输入' + item.label"></el-input>
              <el-button class="item_card_btn" type="danger" circle
                         v-if="scope.row[item.prop + 'Btn']==false?false:true"
                         @click="(e)=>{if((item.click)&&item.disabled==true?false:true)item.click(e, scope.row)}">
                <el-icon class="item_card_btn_icon" size="14" color="#ffffff">
                  <Close/>
                </el-icon>
              </el-button>
            </template>
            <!-- select -->
            <template v-if="item.type == 'select'">
              <el-select v-model="scope.row[item.prop]"
                         :disabled="scope.row[item.prop+'disabled']?true:false"
                         :multiple="item.multiple==true?true:false"
                         :placeholder="item.placeholder?item.placeholder:'请选择' + item.label"
                         @change="(e)=>{if(item.change)item.change(e, scope.row, scope.$index)}">
                <el-option v-for="(temp,index1) in item.sourceList" :key="index1"
                           :label="item.sourceProp?temp[item.sourceProp.text]:temp.text"
                           :value="item.sourceProp?temp[item.sourceProp.value]:temp.value"></el-option>
              </el-select>
            </template>
            <!-- selectImg -->
            <template v-if="item.type == 'selectImg'">
              <el-select v-model="scope.row[item.prop]"
                         :disabled="scope.row[item.prop+'disabled']?true:false"
                         :multiple="item.multiple==true?true:false"
                         :placeholder="item.placeholder?item.placeholder:'请选择' + item.label"
                         @change="(e)=>{if(item.change)item.change(e, scope.row, scope.$index)}">
                <template #prefix>
                  <el-image class="selectImg_img" v-if="scope.row[item.prop] == 1"
                            :src="require('@/assets/meituan.png')"></el-image>
                  <el-image class="selectImg_img" v-if="scope.row[item.prop] == 7"
                            :src="require('@/assets/meituan.png')"></el-image>
                  <el-image class="selectImg_img" v-if="scope.row[item.prop] == 2"
                            :src="require('@/assets/weixin.png')"></el-image>
                  <el-image class="selectImg_img" v-if="scope.row[item.prop] == 3"
                            :src="require('@/assets/zhifubao.png')"></el-image>
                  <el-image class="selectImg_img" v-if="scope.row[item.prop] == 4"
                            :src="require('@/assets/xianjin.png')"></el-image>
                  <el-image class="selectImg_img" v-if="scope.row[item.prop] == 5"
                            :src="require('@/assets/huiyuanka.png')"></el-image>
                  <el-image class="selectImg_img" v-if="scope.row[item.prop] == 6"
                            :src="require('@/assets/qita.png')"></el-image>
                  <el-image class="selectImg_img" v-if="scope.row[item.prop] == 8"
                            :src="require('@/assets/meituan.png')"></el-image>
                  <el-image class="selectImg_img" v-if="scope.row[item.prop] == 9"
                            :src="require('@/assets/douyin.png')"></el-image>
                  <el-image class="selectImg_img" v-if="scope.row[item.prop] == 10"
                            :src="require('@/assets/kuaishou.png')"></el-image>
                  <el-image class="selectImg_img" v-if="scope.row[item.prop] == 11"
                            :src="require('@/assets/daijinquan.png')"></el-image>
                  <el-image class="selectImg_img" v-if="scope.row[item.prop] == 12"
                            :src="require('@/assets/fukuanma.png')"></el-image>
                  <el-image class="selectImg_img" v-if="scope.row[item.prop] == 13"
                            :src="require('@/assets/weimeng.png')"></el-image>
                  <el-image class="selectImg_img" v-if="scope.row[item.prop] == 14"
                            :src="require('@/assets/meituan.png')"></el-image>
                  <el-image class="selectImg_img" v-if="scope.row[item.prop] == 15"
                            :src="require('@/assets/meituan.png')"></el-image>
                  <el-image class="selectImg_img" v-if="scope.row[item.prop] == 16"
                            :src="require('@/assets/weidian.png')"></el-image>
                  <el-image class="selectImg_img" v-if="scope.row[item.prop] == 17"
                            src="https://script-res-cdn.jxkj1987.cn/eoms_image/icon/eoms_vip.png"></el-image>
                  <el-image class="selectImg_img" v-if="scope.row[item.prop] == 18"
                            :src="require('@/assets/fankeyuding.png')"></el-image>
                  <el-image class="selectImg_img" v-if="scope.row[item.prop] == 20"
                            :src="require('@/assets/huifu.png')"></el-image>
                  <el-image class="selectImg_img" v-if="scope.row[item.prop] == 21"
                            :src="require('@/assets/gaode.png')"></el-image>
                  <el-image class="selectImg_img" v-if="scope.row[item.prop] == 23"
                            :src="require('@/assets/maitao.png')"></el-image>
                </template>
                <el-option v-for="(temp,index1) in item.sourceList" :key="index1"
                           :label="item.sourceProp?temp[item.sourceProp.text]:temp.text"
                           :value="item.sourceProp?temp[item.sourceProp.value]:temp.value">
                  <div class="selectImg_wrap">
                    <!--   美团预定        -->
                    <el-image class="selectImg_img" v-if="(item.sourceProp?temp[item.sourceProp.value]:temp.value) == 1"
                              :src="require('@/assets/meituan.png')"></el-image>
                    <!--   微信             -->
                    <el-image class="selectImg_img" v-if="(item.sourceProp?temp[item.sourceProp.value]:temp.value) == 2"
                              :src="require('@/assets/weixin.png')"></el-image>
                    <!--    支付宝                -->
                    <el-image class="selectImg_img" v-if="(item.sourceProp?temp[item.sourceProp.value]:temp.value) == 3"
                              :src="require('@/assets/zhifubao.png')"></el-image>
                    <!--      现金              -->
                    <el-image class="selectImg_img" v-if="(item.sourceProp?temp[item.sourceProp.value]:temp.value) == 4"
                              :src="require('@/assets/xianjin.png')"></el-image>
                    <!--      会员卡            -->
                    <el-image class="selectImg_img" v-if="(item.sourceProp?temp[item.sourceProp.value]:temp.value) == 5"
                              :src="require('@/assets/huiyuanka.png')"></el-image>
                    <!--      其它          -->
                    <el-image class="selectImg_img" v-if="(item.sourceProp?temp[item.sourceProp.value]:temp.value) == 6"
                              :src="require('@/assets/qita.png')"></el-image>
                    <!--      美团           -->
                    <el-image class="selectImg_img" v-if="(item.sourceProp?temp[item.sourceProp.value]:temp.value) == 7"
                              :src="require('@/assets/meituan.png')"></el-image>
                    <!--      美团           -->
                    <el-image class="selectImg_img" v-if="(item.sourceProp?temp[item.sourceProp.value]:temp.value) == 8"
                              :src="require('@/assets/meituan.png')"></el-image>
                    <!--      抖音           -->
                    <el-image class="selectImg_img" v-if="(item.sourceProp?temp[item.sourceProp.value]:temp.value) == 9"
                              :src="require('@/assets/douyin.png')"></el-image>
                    <!--      快手           -->
                    <el-image class="selectImg_img"
                              v-if="(item.sourceProp?temp[item.sourceProp.value]:temp.value) == 10"
                              :src="require('@/assets/kuaishou.png')"></el-image>
                    <!--      代金券           -->
                    <el-image class="selectImg_img"
                              v-if="(item.sourceProp?temp[item.sourceProp.value]:temp.value) == 11"
                              :src="require('@/assets/daijinquan.png')"></el-image>
                    <!--      付款吗           -->
                    <el-image class="selectImg_img"
                              v-if="(item.sourceProp?temp[item.sourceProp.value]:temp.value) == 12"
                              :src="require('@/assets/fukuanma.png')"></el-image>
                    <!--      微盟           -->
                    <el-image class="selectImg_img"
                              v-if="(item.sourceProp?temp[item.sourceProp.value]:temp.value) == 13"
                              :src="require('@/assets/weimeng.png')"></el-image>
                    <!--      美团降佣1              -->
                    <el-image class="selectImg_img"
                              v-if="(item.sourceProp?temp[item.sourceProp.value]:temp.value) == 14"
                              :src="require('@/assets/meituan.png')"></el-image>
                    <!--      美团降佣2           -->
                    <el-image class="selectImg_img"
                              v-if="(item.sourceProp?temp[item.sourceProp.value]:temp.value) == 15"
                              :src="require('@/assets/meituan.png')"></el-image>
                    <!--      微店           -->
                    <el-image class="selectImg_img"
                              v-if="(item.sourceProp?temp[item.sourceProp.value]:temp.value) == 16"
                              :src="require('@/assets/weidian.png')"></el-image>
                    <!--      储值会员卡           -->
                    <el-image class="selectImg_img"
                              v-if="(item.sourceProp?temp[item.sourceProp.value]:temp.value) == 17"
                              src="https://script-res-cdn.jxkj1987.cn/eoms_image/icon/eoms_vip.png"></el-image>
                    <!--      凡客预定           -->
                    <el-image class="selectImg_img"
                              v-if="(item.sourceProp?temp[item.sourceProp.value]:temp.value) == 18"
                              :src="require('@/assets/fankeyuding.png')"></el-image>
                    <!--      极迅小白盒子           -->
                    <el-image class="selectImg_img"
                              v-if="(item.sourceProp?temp[item.sourceProp.value]:temp.value) == 20"
                              :src="require('@/assets/huifu.png')"></el-image>
                    <el-image class="selectImg_img"
                              v-if="(item.sourceProp?temp[item.sourceProp.value]:temp.value) == 21"
                              :src="require('@/assets/gaode.png')"></el-image>
                    <el-image class="selectImg_img"
                              v-if="(item.sourceProp?temp[item.sourceProp.value]:temp.value) == 23"
                              :src="require('@/assets/maitao.png')"></el-image>
                    <div>{{ item.sourceProp ? temp[item.sourceProp.text] : temp.text }}</div>
                  </div>
                </el-option>
              </el-select>
            </template>
            <!-- timePicker -->
            <template v-if="item.type == 'timePicker'">
              <el-time-select v-model="scope.row[item.prop]" :disabled="scope.row[item.prop+'_disabled']?true:false"
                              :format="item.format?item.format:'HH:mm:ss'"
                              @change="(e)=>{if(item.change)item.change(e, scope.row, scope.$index)}"
                              :start="scope.row[item.prop+'_start']?scope.row[item.prop+'_start']:'00:00'"
                              :end="scope.row[item.prop+'_end']?scope.row[item.prop+'_end']:'23:59'"
                              :step="scope.row[item.prop+'_step']?scope.row[item.prop+'_step']:'00:30'"
                              :placeholder="item.placeholder?item.placeholder:'请选择' + item.label"></el-time-select>
            </template>
            <!-- mtTime -->
            <template v-if="item.type == 'mtTime'">
              <el-dropdown trigger="click" ref="mtTime" max-height="300"
                           :disabled="scope.row[item.prop+'_disabled']?true:false">
                <div class="diy" style="height: 32px;"
                     :class="scope.row[item.prop]?'diy_value':'',scope.row[item.prop+'_disabled']?'disabled':''">
                  <el-icon size="15" color="#ababab" style="margin-right: 10px">
                    <Clock/>
                  </el-icon>
                  <span v-if="scope.row[item.prop]">{{ scope.row[item.prop] }}</span>
                  <span v-else>{{ item.placeholder ? item.placeholder : '请选择' + item.label }}</span>
                </div>
                <template #dropdown>
                  <div class="mtTime">
                    <div class="mtTime_date">
                      <div class="mtTime_item" :class="item.day == 'today'?'mtTime_item_select':''"
                           @click="(e)=>{mtTimeClick('day', 'today', item, scope.row)}">今日
                      </div>
                      <div class="mtTime_item" :class="item.day == 'tomorrow'?'mtTime_item_select':''"
                           @click="(e)=>{mtTimeClick('day', 'tomorrow', item, scope.row)}" v-if="item.tomorrow">次日
                      </div>
                    </div>
                    <div class="mtTime_date">
                      <el-scrollbar>
                        <template v-for="(data,k) in item.mtHrList ">
                          <div class="mtTime_item" :class="item.hour == data?'mtTime_item_select':''"
                               @click="(e)=>{mtTimeClick('hour', data, item, scope.row)}">{{ data }}
                          </div>
                        </template>
                      </el-scrollbar>
                    </div>
                    <div class="mtTime_date">
                      <el-scrollbar>
                        <template v-for="(data,k) in item.mtMinList ">
                          <div class="mtTime_item" :class="item.minute == data?'mtTime_item_select':''"
                               @click="(e)=>{mtTimeClick('minute', data, item, scope.row)}">{{ data }}
                          </div>
                        </template>
                      </el-scrollbar>
                    </div>
                  </div>
                </template>
              </el-dropdown>
            </template>
            <!-- 按钮组 -->
            <div v-if="item.type == 'button'">
              <template v-for="(btn, idx) in item.buttons" :key="idx">
                <el-tooltip v-if="scope.row[btn.prop + 'Btn']==false?false:true" :content="btn.label" placement="top"
                            :show-after="1000">
                  <el-button class="table_btn" @click="btnClick(btn.prop, scope.row, scope.$index)" size="small"
                             :type="btn.type?btn.type:'primary'" v-access="btn.access?btn.access:''"
                             :disabled="scope.row[item.prop+'disabled']?true:false"
                             :style="scope.row[btn.prop + '_btn_style']?scope.row[btn.prop + '_btn_style']:''">
                    <el-icon size="15" v-if="btn.icon">
                      <component :is="btn.icon"></component>
                    </el-icon>
                    <el-icon size="15" v-else-if="btn.svg">
                      <svg-icon :icon-class="btn.svg"></svg-icon>
                    </el-icon>
                  </el-button>
                </el-tooltip>
              </template>
            </div>
            <!-- 自定义按钮 -->
            <div v-if="item.type == 'diyButton'">
              <el-button class="table_btn" @click="(e)=>{item.click(item,scope.row, scope.$index)}"
                         :disabled="scope.row[item.prop+'_disabled']==true?true:false"
                         v-show="scope.row[item.prop+'_show']==false?false:true"
                         :style="scope.row[item.prop + '_btn_style']?scope.row[item.prop + '_btn_style']:''">
                <el-icon size="15" v-if="item.icon">
                  <component :is="item.icon"></component>
                </el-icon>
                <el-icon size="15" v-else-if="item.svg">
                  <svg-icon :icon-class="item.svg"></svg-icon>
                </el-icon>
                <span>{{ scope.row[item.prop] }}</span>
              </el-button>
            </div>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <!-- isPagination:是否展示分页,默认展示,不展示传isPagination:false -->
    <div v-if="tableData.form&&!tableData.form.isPagination&&tableData.form.isPagination!=false"
         class="table_pagination">
      <el-pagination
          :current-page="tableData.form.page"
          :page-size="tableData.form.limit"
          :page-sizes="tableData.form.pageSizes?tableData.form.pageSizes:[10, 15, 30, 40, 50]"
          background
          :layout="'sizes,total, ->, prev, pager, next, jumper'"
          :total="tableData.form.total"
          @size-change="onTableSizeChange"
          @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
    <slot name="footer"></slot>
  </div>
</template>

<script>
//region tableData数据说明
/* tableData:{
     //table的表单数据,不显示则null
     form: {
         page: 1,                //页数
         limit: this.$tools.getLimit("companyManage"), //条数,从缓存里取出上次选择条数
         total: 0,               //总数
         isPagination:false,     //是否显示分页
         pageSizes:[10, 15, 30]  //分页每页大小
     },
     //标题
     title:'明细',
     //是否显示合计
     summary:true,
     //table结构
     column: [
         { type: 'selection' },                //选择列
         { type: 'index' },                    //序号列
         {
                 label: "订单类型",             //列显示的文本
                 prop: 'orderType',            //列的key [item.prop+'disabled'] 后面加disabled类型的是表示cell是否可用,true:不可用,false:可用
                 type: 'tag',                  //列类型, text:文本, textBr:文本(换行和提示),image:图片, tag:标签, textLong:长文本, time:时间,
                                                        switch:选择,button:按钮, input:输入框(使用同表单), select:下拉框(使用同表单), qrcode:二维码
                                                        timePicker:时间选择(使用同表单), html:自定义的html
                 show:true,                    //是否显示
                 visible:true,                 //是否有此列的权限
                 width:120,                    //列宽
                 condition:"select",           //条件类型, select:下拉, like模糊, time:时间,date:日期类型, dates:条件按天筛选
                 placeholder:'请选择排序方式',  //提示,如果类型为input,select, 则为输入提示,否则为条件提示
                 sort: 'true/custom'           //是否排序, true:前端排序,custom:后端排序
                 isPower:false,                //是否鉴权,默认true
                 style:false,                  //是否自定义样式,默认false, 配合data中textStyle使用
                 sum: true,                    //合计列

                 tags: [
                     {value:1, type: 'success',text:'主题订单'},
                     {value:2, type: 'success',text:'剧本订单'}
                 ],                             //tag列使用,根据value显示对应text,type值:'默认空'/success/info/warning/danger
                 tagsType:'',                   //tag列使用,值为: '默认空'/success/info/warning/danger,以标签的形式展示文本

                 format:'YYYY-MM-DD',           //time使用,格式化time
                 shortcuts:[],                  //time作为查询条件时候使用,添加快捷选项,除了默认的选项,额外添加['lastWeek', 'lastMonth']

                 change:{},                     //改变回调函数
                 click:{},                      //点击回调函数
                 searchChange:{},               //作为搜索条件时的改变回调函数
         },
         //按钮列, 按钮buttons集合,icon:使用element的图标,svg:自定义的图标,access:鉴权
         { type: 'button', width:180, label: "操作",
            buttons:[
                { label:'审核', prop: 'audit', type:'success', icon:'DocumentChecked', access:'004001005'},
                { label:'取消审核', prop: 'revAudit', type:'warning', icon:'DocumentDelete', access:'004001006'},
                { label:'编辑', prop: 'edit', type:'primary', icon:'EditPen', access:'004001002'},
                { label:'详情', prop: 'info', type:'primary', icon:'ZoomIn', access:'004001008'},
                { label:'删除', prop: 'delete', type:'danger', icon:'Delete', access:'004001007'},
                { label:'删除(我创建的)', prop: 'deleteSelf', type:'danger', icon:'Delete', access:''},
                { label:'开始计时', prop: 'start', type:'success', svg:'start', access:'004001003'},
                { label:'停止计时', prop: 'stop', type:'danger', svg:'stop', access:'004001004'},
                { label:'暂停计时', prop: 'suspend', type:'warning', svg:'suspend', access:'004001010'},
                { label:'继续计时', prop: 'continue', type:'warning', svg:'start', access:'004001011'},
            ],
         },
     ],
     //table的显示数据, select:是否勾选,textStyle:自定义的样式,
     //['editBtn'] 数据中xxBtn的是表示按钮是否显示,true:默认显示,false:不显示
     //['edit_btn_style'] 数据中edit_btn_style是自定义按钮的样式
     data: [],
     //tab条件
     tab:{
         tabList: ['续存', '注销'],       //条件列表
         tabData: '续存',                //条件值
         tabClick: res => {},            //点击事件
     },
     //查询回调, res:自定义数据
     searchClick: res => {
         this.searchClick();
     },
     //后端排序回调, res:排序列数据
     sortClick: res => {

     },
     //按钮回调,type:按钮类型, row:行信息
     btnClick: (type, row) => {
         if(type == 'info'){

         }
     }
     //行点击回调,row:行信息
     rowClick: (row) => {
     }
 },*/
//endregion

import formCondition from '@/components/formCondition.vue'

export default {
  name: "tables", //表格组件
  components: {
    formCondition,
  },
  props: {
    tableData: {
      type: null,
      default: null
    },
    tableKey: {          //表示table唯一的key 1.用于获取limit缓存
      type: String,
      default: "tableKey"
    },
    isForm: {            //是否是表单里的表格
      type: Boolean,
      default: false
    },
    isStripe: {            //斑马纹
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      dayJs: this.$dayjs,
      defaultTime: [
        new Date(2000, 1, 1, 0, 0, 0),
        new Date(2000, 2, 1, 23, 59, 59),
      ],
      firstTime: null,
    }
  },
  methods: {

    /**
     * 操作列点击
     */
    btnClick(prop, row, index) {
      //有一些按钮是预设的对话框,比如删除,审核
      switch (prop) {
          //region 审核
        case 'audit':
          this.$confirm("确定要审核此条数据么?", {
            confirmButtonText: '审核',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            return this.tableData.btnClick('audit', row, index)
          });
          break;
          //endregion
          //region 取消审核
        case 'revAudit':
          this.$confirm("确定要取消此条数据的审核么?", {
            confirmButtonText: '反审',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            return this.tableData.btnClick('revAudit', row, index)
          });
          break;
          //endregion
          //region 删除
        case 'delete':
          this.$confirm("确定要删除此条数据么?", {
            confirmButtonText: '删除',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            return this.tableData.btnClick('delete', row, index)
          });
          break;
          //endregion
        default:
          return this.tableData.btnClick(prop, row, index);
      }
    },

    /**
     * 合计事件
     */
    getSummaries(param) {
      let data = param.data;
      let sums = [];
      for (let k = 0; k < this.tableData.column.length; k++) {
        if (this.tableData.column[k].type == "index") {
          sums.push("合计");
        }
        //只统计展示列
        else if ((this.tableData.column[k].visible == false ? false : true) && (this.tableData.column[k].show == false ? false : true)) {
          if (this.tableData.column[k].sum) {
            let total = 0;
            for (let i = 0; i < data.length; i++) {
              // 跳过会员卡次卡的情况：payMode=17 且 cardType=1
              if (data[i].payMode === 17 &&
                  data[i].cardWallet &&
                  data[i].cardWallet.cardType === 1) {
                continue;
              }

              //如果有特殊行,进行处理,如括号
              let str = data[i][this.tableData.column[k].prop] + "";
              if (str && str !== "null" && str !== "undefined") {
                if (str.indexOf("(") >= -1) {
                  let num = str.split("(")[0];
                  total = this.$tools.accAdd(total, num)
                } else {
                  total = this.$tools.accAdd(total, str)
                }
              }
            }
            sums.push(total ? total : "")
          } else {
            sums.push("")
          }
        }

      }
      return sums
    },

    /**
     * 美团时间点击
     */
    mtTimeClick(type, data, item, row) {
      switch (type) {
          //region 天
        case 'day':
          item.day = data;
          //判断是否已选完
          if (item.day && item.hour && item.minute) {
            //设置日期
            let baseDay = this.$dayjs().format("YYYY-MM-DD");
            if (item.day == 'tomorrow') {
              baseDay = this.$dayjs().add(1, 'day').format("YYYY-MM-DD");
            }
            //关闭所有选择时间
            let refs = this.$refs['mtTime'];
            if (refs && refs.length > 0) {
              for (let i = 0; i < refs.length; i++) {
                refs[i].handleClose();
              }
            }
            //回调
            if (item.change) {
              item.change(baseDay + " " + item.hour + ":" + item.minute, row, item)
            }
            //清空已选
            item.hour = "";
            item.minute = "";
          }
          break;
          //endregion
          //region 小时
        case 'hour':
          item.hour = data;
          //判断是否已选完
          if (item.day && item.hour && item.minute) {
            //设置日期
            let baseDay = this.$dayjs().format("YYYY-MM-DD");
            if (item.day == 'tomorrow') {
              baseDay = this.$dayjs().add(1, 'day').format("YYYY-MM-DD");
            }
            //关闭所有选择时间
            let refs = this.$refs['mtTime'];
            if (refs && refs.length > 0) {
              for (let i = 0; i < refs.length; i++) {
                refs[i].handleClose();
              }
            }
            //回调
            if (item.change) {
              item.change(baseDay + " " + item.hour + ":" + item.minute, row, item)
            }
            //清空已选
            item.hour = "";
            item.minute = "";
          }
          break;
          //endregion
          //region 分钟
        case 'minute':
          item.minute = data;
          //判断是否已选完
          if (item.day && item.hour && item.minute) {
            //设置日期
            let baseDay = this.$dayjs().format("YYYY-MM-DD");
            if (item.day == 'tomorrow') {
              baseDay = this.$dayjs().add(1, 'day').format("YYYY-MM-DD");
            }
            //关闭所有选择时间
            let refs = this.$refs['mtTime'];
            if (refs && refs.length > 0) {
              for (let i = 0; i < refs.length; i++) {
                refs[i].handleClose();
              }
            }
            //回调
            if (item.change) {
              item.change(baseDay + " " + item.hour + ":" + item.minute, row, item)
            }
            //清空已选
            item.hour = "";
            item.minute = "";
          }
          break;
          //endregion
      }

    },

    /**
     * 排序点击
     */
    sortClick(e) {
    },

    /**
     * 文本输入(校验数据)
     */
    handleInput(e, index) {
      //根据isValid过滤数据
      if (e.isValid) {
        switch (e.isValid) {
          case "integer":
            var val = this.tableData.data[index][e.prop];

            if (val === null || val === undefined) {
              val = '';
            } else {
              val = String(val);
            }

            // 1️⃣ 只保留数字
            val = val.replace(/\D/g, '');

            // 2️⃣ 处理前导0
            if (val.length > 1) {
              val = val.replace(/^0+/, '');
            }

            this.tableData.data[index][e.prop] = val;
            break;
            //region 数字
          case "number":
            this.tableData.data[index][e.prop] = this.tableData.data[index][e.prop].replace(/[^\d.]/g, '');

            break;
            //endregion
            //region 只能输入数字和两位小数
          case "money":
            this.tableData.data[index][e.prop] = this.tableData.data[index][e.prop].replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
            this.tableData.data[index][e.prop] = this.tableData.data[index][e.prop].replace(/^\./g, ""); //验证第一个字符是数字
            this.tableData.data[index][e.prop] = this.tableData.data[index][e.prop].replace(/\.{2,}/g, ""); //只保留第一个, 清除多余的
            this.tableData.data[index][e.prop] = this.tableData.data[index][e.prop].replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
            this.tableData.data[index][e.prop] = this.tableData.data[index][e.prop].replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
            break;
            //endregion
        }
      }
      //如果有回调

      if (e.input) {

        return e.input(e, index);
      }

    },
    /**
     * 输入框失焦
     */
    handleBlur(e, index) {
      //根据isValid过滤数据
      if (e.isValid) {
        switch (e.isValid) {
            //region 数字
            // case "number":
            //   this.tableData.data[index][e.prop] = this.tableData.data[index][e.prop].replace(/[^\d.]/g,'');
            //   break;
            //   //endregion
            //   //region 只能输入数字和两位小数
            // case "money":
            //   this.tableData.data[index][e.prop] = this.tableData.data[index][e.prop].replace(/[^\d.]/g,""); //清除"数字"和"."以外的字符
            //   this.tableData.data[index][e.prop] = this.tableData.data[index][e.prop].replace(/^\./g,""); //验证第一个字符是数字
            //   this.tableData.data[index][e.prop] = this.tableData.data[index][e.prop].replace(/\.{2,}/g,""); //只保留第一个, 清除多余的
            //   this.tableData.data[index][e.prop] = this.tableData.data[index][e.prop].replace(".","$#$").replace(/\./g,"").replace("$#$",".");
            //   this.tableData.data[index][e.prop] = this.tableData.data[index][e.prop].replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3'); //只能输入两个小数
            //   break;
            //endregion
        }
      }
      //如果有回调
      if (e.blur) {
        return e.blur(e, index);
      }
    },
    /**
     * 选择改变点击
     */
    handleSelectionChange(rows) {
      for (let i = 0; i < this.tableData.data.length; i++) {
        this.tableData.data[i].select = false;
        for (let k = 0; k < rows.length; k++) {
          if (this.tableData.data[i] == rows[k]) {
            this.tableData.data[i].select = true
          }
        }
      }
    },

    /**
     * 查询点击
     */
    searchClick: function () {
      this.tableData.form.page = 1;
      this.tableData.form.current = 1;
      //回调
      return this.tableData.searchClick()
    },

    /**
     * 页数数量改变点击
     */
    onTableSizeChange(e) {
      this.tableData.form.limit = e;
      this.$tools.setLimit(this.tableKey, e);
      this.searchClick();
    },

    /**
     * 翻页点击
     */
    handleCurrentChange(e) {
      this.tableData.form.page = parseInt(e);
      this.tableData.form.current = parseInt(e);
      return this.tableData.searchClick()
    },

  },
  mounted() {

  }
}
</script>

<style>
.table_column {
  /*font-weight: 800;*/
  color: #333333;
}
</style>
<style scoped>
/*在index序号中关闭样式*/
.item_card_btn {
  position: absolute;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  top: -21px;
  left: -21px;
  color: #ffffff;
}

.item_card_btn_icon {
  position: relative;
  left: 9px;
  top: 8px;
  color: #ffffff;
}

:deep(.el-table__cell) {
  overflow: hidden;
}

/*下拉带支付方式图标*/
.selectImg_wrap {
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.selectImg_img {
  width: 24px;
  height: 24px;
  margin-right: 4px;
}

/*去掉Table选中出现黑框的问题*/
:deep(tbody) {
  outline: none !important;
}

/*去掉select悬浮不出现小手问题*/
:deep(.el-select__wrapper) {
  cursor: pointer !important;
}

/*去掉select选中出现黑框问题*/
:deep(.el-select__wrapper:focus) {
  outline: none !important;
}

/*美团选择时间*/
.mtTime {
  position: relative;
  width: 200px;
  display: flex;
  justify-content: flex-start;
  font-size: 14px;
}

.mtTime_date {
  position: relative;
  width: 33%;
  padding-top: 10px;
  padding-bottom: 10px;
  border-right: 1px solid #f0f0f0;
  max-height: 280px;
}

.mtTime_item {
  position: relative;
  width: 100%;
  height: 34px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.mtTime_item:hover {
  color: #ffbe88;
}

.mtTime_item_select {
  background: #ff6633;
  color: #ffffff;
  border-radius: 2px;
}

.diy {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  flex-grow: 1;
  padding: 1px 11px;
  background-color: #ffffff;
  background-image: none;
  border-radius: 4px;
  transition: var(--el-transition-box-shadow);
  box-shadow: 0 0 0 1px #dcdfe6 inset;
  width: 180px;
  cursor: pointer;
  color: #331b0f;
}

.diy:hover {
  box-shadow: 0 0 0 1px #409eff inset !important;
}

.diy:focus {
  outline: none !important;
}

.diy_value {
  color: #333333;
}

.disabled {
  color: #ababab;
  background: #f5f7fa;
  cursor: not-allowed;
}

.disabled:hover {
  box-shadow: 0 0 0 1px #dcdfe6 inset;
}

.table_title {
  position: relative;
  height: 30px;
  font-size: 16px;
}

.table_title_icon {
  position: relative;
  bottom: 0;
  height: 12px;
  width: 6px;
  background: linear-gradient(to bottom, #ff6633, #ff6633);
  border-radius: 4px;
  margin-right: 4px;
  display: inline-block;
}

.search {
  position: relative;
  width: 100%;
  margin-top: 14px;
}

.row {
  width: 160px;
}

:deep(.el-form--inline .el-form-item) {
  margin-right: 20px;
}

:deep(.el-image__wrapper ) {
  top: 2px;
}

:deep(.el-image__error) {
  line-height: 14px;
  font-size: 12px;
}

.table_pagination {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  background-color: #ffffff;
  padding-top: 8px;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 8px;
  border-left: 1px solid #f2f2f2;
  border-right: 1px solid #f2f2f2;
  border-bottom: 1px solid #f2f2f2;
}

.table_img {
  display: inline-block;
  height: 33px;
  width: 33px;
  margin-right: 4px;
  cursor: pointer;
  top: 3px;
}

.table_btn {
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.table_textLong {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.form_btn {
  padding-left: 10px;
  padding-right: 10px;
}

</style>
